import { useEffect, useState } from 'react';
import { Remote } from '@/api/remote';
import { ApiConstant } from '@/constants/api_constants';
import { Constants } from '@/constants/constants';
import LayerPopup from './LayerPopup';
import type { HomePopupListResponse, PopupResponseItem, PopupSlide } from './popup.interface';

const toPopupSlides = (list: PopupResponseItem[], defaultAlt: string): PopupSlide[] =>
	list
		.map((item, index) => ({
			id: String(item.popupId ?? item.id ?? index),
			isImage: item.imgYn === 'Y',
			content: item.popupCtnt ?? '',
			alt: item.popupTitl || item.popupNm || defaultAlt,
			link: item.popupLinkUrl || undefined,
			linkTarget: (item.urlRedirectType === 'URLRDTP001' ? '_blank' : '_self') as '_blank' | '_self'
		}))
		.filter(slide => slide.content.trim() !== '');

const fetchHomePopups = async (): Promise<HomePopupListResponse> => {
	const response = await Remote.Api.get(ApiConstant.mgmtHomePopup.listHomepage);
	if (response?.code !== Constants.apiSuccess) throw new Error(response?.message ?? 'Failed to load homepage popups');
	return response.content ?? {};
};

const LayerPopupGroup = () => {
	const [noticeSlides, setNoticeSlides] = useState<PopupSlide[]>([]);
	const [eventSlides, setEventSlides] = useState<PopupSlide[]>([]);

	useEffect(() => {
		let alive = true;
		const loadPopups = async () => {
			try {
				const lists = await fetchHomePopups();
				if (!alive) return;
				setNoticeSlides(toPopupSlides(lists.homePopUpNoticeList ?? [], '공지사항'));
				setEventSlides(toPopupSlides(lists.homePopUpEventList ?? [], '이벤트'));
			} catch (error) {
				if (alive) console.error('레이어 팝업 로딩 실패:', error);
			}
		};
		loadPopups();
		return () => {
			alive = false;
		};
	}, []);

	if (noticeSlides.length === 0 && eventSlides.length === 0) return null;

	return (
		<div className={'layer-popup-group'}>
			<LayerPopup type="event" items={eventSlides} />
			<LayerPopup type="notice" items={noticeSlides} />
		</div>
	);
};

export default LayerPopupGroup;
